import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useLocation, useHistory  } from 'react-router-dom';
import settings from '../../config/settings';


const Registrationsuccess = () => {
    const location = useLocation();
    const data = location.state;
    const routerHistory = useHistory();

    useEffect(() => {
        const redirectUrl = sessionStorage.getItem('post_payment_redirect');
        const alreadyRedirected =
        sessionStorage.getItem('post_payment_redirect_done') === 'true';

        // If user refreshed or data is missing
        if (!redirectUrl || !data?.isSportsInternationalCamp) {
            // routerHistory.replace('/camps');
            return;
        }

        // Redirect ONLY once
        if (!alreadyRedirected) {
            // console.log(`Redirecting to football camps in 3 seconds`);
            // console.log(`Redirect info : ${redirectUrl}`);
            const timer = setTimeout(() => {
                sessionStorage.setItem('post_payment_redirect_done', 'true');
                // Clean up AdShopper data after redirect
                sessionStorage.removeItem('adshopper_conversion');
                window.location.href = redirectUrl;
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [routerHistory]);

    return(
        <div className="body_container">
                {/* {settings.api.gogleTagManagerUrl && data?.isSportsInternationalCamp &&
                    <iframe
                        src="https://footballcamps.com/registrationsuccess/"
                        style={{ display: 'none' }} 
                        title="Background Webpage"
                    />
                } */}
                 <div className="container booking_success">
                     
                     <img src={require('../../assets/img/booking-done.png')} />
                        <h2>Congrats!</h2>
                        {/* <p>Please add the <b>free “CampsEZ” mobile app,</b> on the Apple or Android store. Follow the links or search “CampsEZ” on the stores. This will help the program providers keep you updated of news you need to know and if any change occur.</p>
                        <div className="apps_links mt-4 mb-4">
                            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.vic.campsez"><img src={require('../../assets/img/google-play.png')} /></a>
                            <a target="_blank" href="https://apps.apple.com/us/app/campsez/id1521620775"><img src={require('../../assets/img/app-store.png')} /></a>
                        </div>
                        <p>Congratulations your registration has been confirmed. A confirmation email has been sent to you. If you do not receive this email within 24 hrs please contact us at the phone number or email at the top left of this page</p>  */}
                   
                     <p>Thank you! We look forward to continuing to serve you!</p>
                    <Link className="btn btn-primary rounded-0 ps-4 pe-4 mt-5" to="/camps">Continue Exploring</Link>
                 </div>

                 <Helmet>
                    <script>
                    {`
                        !function(f,b,e,v,n,t,s)
                        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', '160201611266653');
                        fbq('track', 'PageView');
                    `}
                    </script>

                    {/* AdShopper Conversion Tracking - Sports International Only */}
                    {data?.isSportsInternationalCamp && (
                        <script>
                        {`
                            (function() {
                                try {
                                    var adShopperData = JSON.parse(sessionStorage.getItem('adshopper_conversion') || '{}');
                                    var trafficSource = JSON.parse(localStorage.getItem('traffic_source') || '{}');

                                    if (typeof AddShoppers !== 'undefined' && adShopperData.orderId) {
                                        var conversionData = {
                                            orderId: adShopperData.orderId,
                                            orderValue: adShopperData.orderValue,
                                            initialPayment: adShopperData.initialPayment,
                                            currency: adShopperData.currency,
                                            email: adShopperData.email,
                                            phone: adShopperData.phone,
                                            programs: adShopperData.programs,
                                            programCode: adShopperData.programCode,
                                            referralSource: adShopperData.referralSource,
                                            source: adShopperData.source,
                                            sku: adShopperData.sku
                                        };

                                        // Include AdShopper click tracking data if available
                                        if (trafficSource.adshopperClickId) {
                                            conversionData.clickId = trafficSource.adshopperClickId;
                                        }
                                        if (trafficSource.utmSource) {
                                            conversionData.utmSource = trafficSource.utmSource;
                                        }
                                        if (trafficSource.utmMedium) {
                                            conversionData.utmMedium = trafficSource.utmMedium;
                                        }
                                        if (trafficSource.utmCampaign) {
                                            conversionData.utmCampaign = trafficSource.utmCampaign;
                                        }

                                        AddShoppers.track('conversion', conversionData);
                                    }
                                } catch (e) {
                                    console.error('AdShopper tracking error:', e);
                                }
                            })();
                        `}
                        </script>
                    )}
                </Helmet>
        </div>
    )
}

export default Registrationsuccess;